import { legacyGet, legacyPost } from '../legacy-client';
import type {
  Station,
  StationsResponse,
  StationDetails,
  ClearPortsDto,
  UnassignStationDto,
  SuccessResponse,
  LinuxServer,
  ClientCardResponse,
  WaitingStation,
  AssignStationDto,
  AllErrorsResponse,
  UnassignedStation,
} from './types';

export const legacyStationsApi = {
  /**
   * Get stations for a specific client (sobid) - brief info
   */
  getByClient: async (sobid: number): Promise<Record<string, Station>> => {
    const response = await legacyGet<StationsResponse>('getStations', {
      sobid,
    });
    return response.stations || {};
  },

  /**
   * Get detailed station info (reports, logs, tasks)
   */
  getDetails: async (sobid: number, stationName: string): Promise<StationDetails> =>
    legacyGet<StationDetails>('getStationDetails', {
      sobid,
      station: stationName,
    }),

  /**
   * Refresh port scan data for a station
   */
  clearPorts: async (sobid: number, dto: ClearPortsDto): Promise<SuccessResponse> =>
    legacyPost<SuccessResponse, ClearPortsDto & { sobid: number }>('clearPorts', {
      sobid,
      ...dto,
    }),

  /**
   * Unassign station from client
   */
  unassignStation: async (sobid: number, dto: UnassignStationDto): Promise<SuccessResponse> =>
    legacyPost<SuccessResponse, UnassignStationDto & { sobid: number }>('unassignStation', {
      sobid,
      ...dto,
    }),

  /**
   * Get Linux servers and netmap info for a client
   */
  getClientCard: async (sobid: number): Promise<LinuxServer[]> => {
    const response = await legacyGet<ClientCardResponse>('getClientCard', {
      sobid,
    });
    return response.servers || [];
  },

  /**
   * Get waiting stations (not assigned to any client)
   */
  getWaitingStations: async (): Promise<WaitingStation[]> => {
    const response = await legacyGet<Record<string, WaitingStation>>('listWaitingStations');
    return Object.values(response || {});
  },

  /**
   * Assign a waiting station to a client
   */
  assignStation: async (sobid: number, clientName: string, dto: AssignStationDto): Promise<SuccessResponse> =>
    legacyPost<SuccessResponse, AssignStationDto & { sobid: number; clientName: string }>('assignStation', {
      sobid,
      clientName,
      ...dto,
    }),

  /**
   * Get all stations with errors across all available clients (Контроль РК)
   */
  getAllErrors: async (): Promise<AllErrorsResponse> =>
    legacyGet<AllErrorsResponse>('getAllErrors'),

  /**
   * Get unassigned (orphaned) stations for the current user
   * These are stations that were previously unassigned from clients
   */
  getUnassigned: async (): Promise<UnassignedStation[]> =>
    legacyGet<UnassignedStation[]>('getUnassigned'),
};
